/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.EditForm = (function () {
    var self = { subscriptions: {}, valueSeparator: "_#_" };
    self._fieldSelector = ".detail-field";
    self._drVisibleFieldSelector = ".detail-field:not(.dr-invisible)";

    self.EditFormParameters = function (selector, modelName) {
        const $editForm = $(selector).find(".edit-form").first();
        $editForm.data("modelName", modelName);
        const r = prepareReduxModel({ container: $editForm, model: Object.assign({ IsCreating: false }, XPortal.Utils.readJsonStr($editForm.attr("data-settings"))) });
        $editForm.attr("data-settings", "");
        const modelPath = XPortal.Store.GetModelPath($(selector), modelName);
        if ($editForm && $editForm.length)
            return Object.assign({
                parentInfo: XPortal.Utils.hrefQuery(window.location, "parentInfo") ? XPortal.Utils.hrefQuery(window.location, "parentInfo") : null,
                modelName, modelPath, selector
            }, r.model);
        return { isBroken: true };
    };

    self.getEventHandlerFor = function (elmnt, eventName) {
        var callback = elmnt.attr(eventName);
        callback = callback ? callback : $($.find("[" + eventName + "]")).attr(eventName);
        return callback = callback ? window["XPortal"]["EditForm"][callback] : false;
    };
    self.Reloaded = function (selector, oncallback, modelName, extramodel, httpstate) {
        $(selector).find(".detail-preload").addClass("d-none");

        if (httpstate && httpstate.xhr) {
            if (httpstate.xhr.status < 200 || httpstate.xhr.status > 399)
                return setTimeout(() => window.location.reload(), 2000);
        }

        if (XPortal.FEditor) XPortal.FEditor.Update({ Container: selector });
        const btitle = jQuery(selector).find(".edit-form-head").attr("data-title") || "";
        if (btitle.length) document.title = btitle;
        modelName = modelName ? modelName : XPortal.Store.getModelName(selector);
        const model = Object.assign(extramodel || {}, self.EditFormParameters(selector, modelName));
        if (!model || model.isBroken) return;
        model.WasValidated = false;
        const { Alias, IsCreating, UniqueId, Keys } = model;
        const entity = { Alias, IsCreating, UniqueId, Fields: self.PrepareReduxFields($(selector)), Keys };
        model.Fields = Object.assign([], entity.Fields);
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FORM_INITIALIZED, formParameters: model });
        XPortal.Grid.MapEntity(entity, null);

        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: entity, model });
        init(selector, modelName);
        if (XPortal.FEditor) {
            XPortal.FEditor.InitEditors(selector);
            XPortal.FEditor.AjaxUpdated(selector);
        }
        if (oncallback) oncallback();
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.LOADED_ENTITY, model: modelName, entity, field: { field: "*" } });
        XPortal.PageHeader.Init(true);
    };
    self.PopupReloaded = function (iselector, oncallback, modelName, exmodel, httpstate) {
        modelName = modelName ? modelName : XPortal.Store.getModelName(iselector);
        executeSafely(self.Reloaded, iselector, oncallback, modelName, { isPopup: true }, httpstate);
        const $page = $(iselector);

        $page.closest(".popup-detail-content").trigger(XPortal.Redusers.ACTIONS.LOADED_ENTITY);

        if ($page.hasClass("detail-page")) {
            const $footer = $page.closest(".modal-content").find(".modal-footer");
            if ($footer.length > 0) {
                moveEditButtonsToFooter($page, $footer);
            }
        }
    };
    self.StartAutoSave = function (modelName) {
        const state = XPortal.Store.GetBaseReduserState();
        const currentModel = state.pageModels[modelName];
        const container = $(currentModel.model.selector);
        const containerWithActions = (currentModel.isPopup) && container.closest(".modal-content").length ? container.closest(".modal-content") : container;
        const button = containerWithActions.find("[data-action=SaveDetail]");
        const isCreating = currentModel.model.IsCreating ? true : false;
        if (container.length < 1) return $.Deferred().resolve();
        if (!currentModel.itemsToSave || currentModel.itemsToSave.length < 1) return $.Deferred().resolve();

        const options = { modelName, container, button, notClose: true, silentMode: true, doNotDisplayErrors: isCreating, IsCreating: isCreating };
        return self.SaveData(modelName, options);
    };
    self.ValidateModel = function (modelName, options, fieldClass, skipClass) {
        options = GetOptions(modelName);
        const r = new $.Deferred();
        const pModel = XPortal.Store.GetModelByName(modelName);
        if (!pModel.model) return r.reject();
        const container = pModel.model.selector ? $(pModel.model.selector) : $("[id=detail-" + pModel.model.NodeId + "]");
        if (container.length < 1) return r.resolve();
        options.modelName = options.modelName || modelName;
        return self.ValidateTask(container, fieldClass || ".detail-field", options, skipClass);
    };

    function subscribeStaticText(modelName, container) {
        const elementsToExclude = [XPortal.CalendarPicker.ControlSelector];
        const model = XPortal.Store.GetModelByName(modelName);
        container.find("[data-metadata-fieldname]").each((ix, x) => {
            const el = $(x);
            if (el.is(".field-ex-format") || el.attr("data-editable") == "1") return;
            const xvalue = XPortal.Template.TemplateToHtml(model.entity, `[[${el.attr("data-metadata-fieldname")}]]`);
            const isEmptyAction = !xvalue || !xvalue.length ? "addClass" : "removeClass";
            if (!el.is(":input") && !el.is(elementsToExclude.join(","))) {
                if (el.text().trim() != xvalue) {
                    el.text(xvalue);
                    el[isEmptyAction]("empty-value-line");
                    el.attr('title', xvalue);
                }
            }
        });
    };

    function initExFormatEditable(selector, modelName) {
        var isOver = false;
        $(selector || "body").on("click", ".has-ex-format-editable", (e) => {
            if ($(e.target).closest('a').length) {
                return;
            }
            if ($(e.target).closest('.ex-format-actions').length)
                return;

            e.stopPropagation();
            if (e.target.classList.contains('icon-question') || e.target.classList.contains('fr-tooltip')) return;
            const $this = $(e.currentTarget);
            const $feditor = $this.find(".field-editor");
            const wasHidden = $feditor.hasClass("d-none");
            const $input = $feditor.find("input");
            $feditor.removeClass("d-none");
            if (wasHidden) {
                const strLength = $input.val().length * 2;
                if ($input.attr('type') == 'text') {
                    $input[0].setSelectionRange(strLength, strLength);
                }
                $input.focus();
            }
            $this.find(".field-ex-format").addClass("d-none");
            $input.on("mouseenter", function () { isOver = true; })
                .on("mouseleave", function () { isOver = false; });
        }).on("click", ".has-ex-format-editable .ex-format-actions .btn-clear", (e) => {
            e.stopPropagation();
            const $editable = $(e.currentTarget).closest(".has-ex-format-editable");
            const $editor = $editable.find(".field-editor");
            const $inputClear = $editor.find(".btn-clear");
            if ($inputClear.length) {
                $inputClear.trigger("click");
            } else {
                $editor.find(".k-clear-value").trigger("click");
            }
        }).on("mousedown", ".has-ex-format-editable .field-editor .k-clear-value", (e) => {
            e.preventDefault();
        }).on("focusout", ".has-ex-format-editable", (e) => {
            if (!isOver) {
                const $this = $(e.currentTarget);
                $this.find(".field-editor").addClass("d-none");
                $this.find(".field-ex-format").removeClass("d-none");
            }
        });
    };

    function init(selector, modelName) {
        selector = selector ? selector : XPortal.Main.DetialFormSelector;
        var container = $(selector);
        executeSafely(XPortal.DynamicFilters.Init, container);
        executeSafely(XPortal.Main.InitEditControls, container, true);
        executeSafely(XPortal.EditActions.Init, { container, modelName });
        executeSafely(subscribeForStoreChanges, selector, modelName);
        XPortal.Store.ForceCloseForm(true);
        executeSafely(XPortal.Validation.ParseElementsIn, container, XPortal.Main.GetChildOrParentForm(container));
        executeSafely(XPortal.Dashboard.Init, selector, modelName);
        executeSafely(initExFormatEditable, selector, modelName);
        executeSafely(XPortal.Main.MapBreadcrumb, selector, modelName);
    };
    function executeSafely(onAction, ...args) {
        try {
            return onAction(...args);
        } catch (ex) {
            if (console) console.error(ex);
        }
    };
    self.IsDirty = function () {
        if (self.changesAlreadyRejected) {
            return false;
        }
        var editParams = XPortal.Store.GetState().editParameters;
        return editParams
            ? editParams.IsCreating || editParams.IsChanged
            : false;
    };
    self.SaveInProgress = function () {
        var form = $(XPortal.Main.DetialFormSelector);
        if (!form.length) {
            return false;
        }

        var modelName = XPortal.Store.getModelName(form);
        var state = XPortal.Store.GetBaseReduserState();
        var currentModel = state.pageModels[modelName];
        return currentModel && currentModel.SaveInProgress;
    };
    self.ValidateTask = function (container, fieldClass, options, skipClass) {
        container = container || $(XPortal.Main.DetialFormSelector);
        var frm = container.find(".edit-form");
        if (frm.length < 1) frm = $(".edit-form");

        if (fieldClass == self._fieldSelector) fieldClass = self._drVisibleFieldSelector;
        return XPortal.Utils.ValidateForm(container.find(fieldClass || self._drVisibleFieldSelector), frm, options, skipClass);
    };
    self.ValidateAllRelatedModels = function (parentContainer, fieldClass, options, skipClass, parentModel) {
        const promise = new Promise((resolve, reject) => {
            let validationErrors = [];
            self.ValidateTask(parentContainer, fieldClass, options, skipClass).then(function () {
                let toValidateGrids = [];
                let toValidateDetails = [];

                for (var mname in XPortal.Store.GetState().pageModels) {
                    if (XPortal.Store.GetParentModelName(mname) == parentModel.model.modelName) {
                        if (mname.toLowerCase().startsWith("gm"))
                            toValidateGrids.push(mname);
                        else if (mname.toLowerCase().startsWith("pm"))
                            toValidateDetails.push(mname);
                    }
                }



                let allModelsValid = true;
                toValidateGrids.forEach((m) => {
                    const model = XPortal.Store.GetModelByName(m);
                    const itemsToSave = model.itemsToSave || [];
                    if (itemsToSave.length < 1) return;

                    const modelValid = XPortal.Store.ValidateGridModel(m, false, false, true);
                    allModelsValid = modelValid && allModelsValid;
                    if (!modelValid)
                        validationErrors.push(`<p>${XPortal.Grid.GetGridValidationError(model, true)}</p>`);
                });

                let validationResultsAmount = toValidateDetails.length;
                const resolving = (exit) => {
                    if (exit || validationResultsAmount-- > 0)
                        if (allModelsValid)
                            resolve();
                        else
                            reject({ validationErrors: validationErrors });
                }

                if (toValidateDetails.length > 0)
                    toValidateDetails.forEach(m => {
                        self.ValidateModel(m, null, fieldClass, skipClass).then(resolving).fail(() => {
                            allModelsValid = false;
                            resolving(true);
                        });
                    });
                else
                    resolving(true);
            }).fail(function () { // when root model validation failed
                validationErrors.push(...getValidationErrors(parentContainer, fieldClass));

                reject({ validationErrors: validationErrors });
            });
        });

        return promise;
    };
    self.RejectAllChanges = function () {
        delete XPortal.Store.GetState().editParameters;
        const models = XPortal.Store.GetState().pageModels;
        for (let mname in models) {
            let model = models[mname];
            delete model.itemsToSave;
            delete model.modifiedFields;
        }
    };
    self.SaveData = function (modelName, options, fieldClass, skipClass, skipPopupActionCompleted) {
        const anyform = $(XPortal.Main.DetialFormSelector);
        if (!modelName) modelName = options.modelName ? options.modelName : (anyform.length ? XPortal.Store.getModelName($(XPortal.Main.DetialFormSelector)) : null);
        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_START, modelName });
        const deferredSave = $.Deferred();
        const pModel = XPortal.Store.GetModelByName(modelName);
        const container = pModel.model.selector ? $(pModel.model.selector) : $("[id=detail-" + pModel.model.NodeId + "]");
        if (!options.container) options.container = container;
        if (!options.modelName) options.modelName = modelName;
        const frm = container.find(".edit-form");
        fieldClass = fieldClass || self._drVisibleFieldSelector;
        const $fields = container.find(fieldClass);
        const fdata = frm.serializeArray();
        const finalRedirectUrl = options && options.button ? options.button.attr("data-finalredirect") : null;
        self.ValidateTask(container, fieldClass || ".detail-field", options, skipClass).then(function () {
            XPortal.Utils.EnsureCollectionDefer("before-save", function adjustEvent(e) {
                e.form = frm;
                e.data = fdata;
                return e;
            }, $fields).then(function () {
                saveEntityHierarchy(frm, options, pModel).then(
                    function (...args) {
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: true });
                        self.ShowServerErrorMessages(args);
                        if (pModel.model.isPopup && !skipPopupActionCompleted) {

                            XPortal.EditActions.popupActionCompleted(options, "SaveDetail", true, finalRedirectUrl);
                        }
                        deferredSave.resolve(...args);
                    },
                    function (...args) {
                        if (console) console.warn('saveEntityHierarchy - error!', args);
                        XPortal.Loader.hide({ 'selector': null });
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });
                        deferredSave.reject(...args);
                    }
                );
            });
        }, function () {
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.SAVE_END, modelName, saved: false });

            XPortal.Store.GetEditEntityToSave(true);
            XPortal.GridInlineEditing.ValidateAllGridModels();
            if (options && options.button) XPortal.Loader.hide({ selector: options.button });

            let validationErrors = getValidationErrors(container, fieldClass);
            deferredSave.reject({ validationErrors: validationErrors });
        });
        return deferredSave.promise();
    };
    function getValidationErrors(container, fieldClass) {
        if (!fieldClass || fieldClass == self._fieldSelector) fieldClass = self._drVisibleFieldSelector;
        const $validated = container.find(fieldClass);
        const fieldErrors = $.map(container.find(".field-validation-error"), function (msg) {
            const $msg = $(msg);
            const forName = $msg.attr("data-valmsg-for");
            if (forName && !$validated.is("[name='" + forName + "']") && !$validated.find("[name='" + forName + "']").length) return null;
            const error = $msg.text().trim();
            if (!error.length) return null;
            const $label = $msg.closest(".form-group, .field-cntr").find("label").eq(0);
            const fieldShownName = ($label.text() || "").replace('*', '').replace('?', '').trim();
            return "<p>" + (fieldShownName.length ? fieldShownName + ": " : "") + error + "</p>";
        });
        return fieldErrors.concat(self.GetGridValidationErrors());
    }
    self.GetGridValidationErrors = function () {
        const models = XPortal.Store.GetState().pageModels;
        return $.map(Object.keys(models), function (modelName) {
            if (!modelName.startsWith("GM.")) return null;
            if (XPortal.Store.ValidateGridModel(modelName, false, false, true)) return null;
            const error = XPortal.Grid.GetGridValidationError(models[modelName], true);
            return error.length ? "<p>" + error + "</p>" : null;
        });
    };
    function saveEntityHierarchy(frm, options, model) {
        return new Promise((onOk, onError) => {
            showHideSaveEntityLoader(options, true);

            const entities = XPortal.Store.GetModelEntityToSave(false, model);
            const entityToSave = entities.length > 0 ? entities.pop() : null;
            const opts = { url: frm.attr('action') ? frm.attr('action') : '/umbraco/surface/detail/HandleSavedData', headers: XPortal.EditActions.FillHeaders({ container: frm }) };
            XPortal.GridInlineEditing.HandleSave(opts, { model: entityToSave }).then(function (state) {
                const result = state ? state.result : false;
                const isSaved = result && !XPortal.GridInlineEditing.IsFailedSaveResult(result);
                XPortal.EditActions.SaveDetailPopup(options, isSaved);
                const data = result ? result.Result : false;
                if (isSaved) {
                    const saveResult = data && data.length
                        ? data[0]
                        : state.model ? { UniqueId: state.model.UniqueId, EntityAlias: model.model.Alias || model.model.EntityAlias, Fields: [] } : null;
                    if (saveResult) {
                        XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_SUCCESS, saveResult, entity: XPortal.Grid.MapEntity(saveResult), entityBefore: XPortal.Grid.MapEntity(XPortal.Store.ConvertSavedEntityToEdit(state.model)), modelName: model.model.modelName, messages: result.Messages });
                        XPortal.Store.RefreshItemsForModel(model.model.modelName);
                    }
                } else {
                    showHideSaveEntityLoader(options, false);
                    if (result && result.Errors && result && !result.Errors.length) $("#errorBox").modal('show');
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_FAIL, result: result, modelName: model.modelName });
                    return onError(result);
                }
                self.SaveChildsHierarchy(options, model).then(function () {
                    onOk((data && data.length > 0) ? true : false);
                    showHideSaveEntityLoader(options, false);
                }, function () {
                    showHideSaveEntityLoader(options, false);
                });
            }, function (data) {
                if (console) console.warn('XPortal.GridInlineEditing.HandleSave - error!' + model.modelName, data);
                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_SAVE_FAIL, result: data.result, modelName: model.modelName });
                XPortal.Loader.show({ showOverlay: true, color: "transparent", overlayBgColor: "rgba(0,0,0,0.5)" }).hide();
                showHideSaveEntityLoader(options, false);
                if (!data || !data.result) return $("#errorBox").modal('show');
                onError(data.result);
            });
        });
    };

    self.RefreshParentModel = function (modelName) {
        return new Promise(function (onOk) {
            if (!modelName || !modelName.startsWith("PM.")) return;
            var model = XPortal.Store.GetModelByName(modelName);
            var uid = model && model.entity ? XPortal.Template.GetObjPropValueByName(model.entity, "uniqueid") : null;
            if (!uid) return onOk();
            var reqModel = { UniqueId: uid, NodeId: model.model.NodeId, EntityAlias: model.model.Alias, parentInfo: model.model.ParentInfo };
            var headers = XPortal.EditActions.FillHeaders({ container: $(model.model.selector) });
            $.ajax({
                url: '/umbraco/surface/detail/RefreshData',
                type: 'POST', dataType: 'json', contentType: 'application/json; charset=utf-8', cache: false,
                data: JSON.stringify({ model: reqModel }),
                headers: Object.assign({ "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() }, headers || {})
            }).done(function (data) {
                var saveResult = data && data.Result && data.Result.length ? data.Result[0] : null;
                if (saveResult) {
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.ITEM_REFRESH, saveResult, entity: XPortal.Grid.MapEntity(saveResult), entityBefore: XPortal.Grid.MapEntity(XPortal.Store.ConvertSavedEntityToEdit(model.entity)), modelName: modelName, messages: data.Messages });
                    XPortal.Store.RefreshItemsForModel(modelName);
                }
                onOk();
            }).fail(function () { onOk(); });
        });
    };

    function showHideSaveEntityLoader(options, show) {
        if (!options || !options.button) return;

        var $buttonsToProcess = [];
        var $visibleBtns = options.button.filter(':visible');
        for (var i = 0; i < $visibleBtns.length; i++) {
            var $tempData = $($visibleBtns[i].closest('ul')).find(".lbl-save-state").filter(function () { return this.innerHTML == this.dataset.saveinprocess }).parent();
            if ($tempData.length) {
                $buttonsToProcess.push($visibleBtns[i]);
            }
        }
        if ($buttonsToProcess.length && show) return XPortal.Loader.show({ selector: $buttonsToProcess, bgcolor: '#aaaaaa', color: '#ffffff' });
        XPortal.Loader.hide({ selector: options.button });
    };
    function subscribeForStoreChanges(selector, modelName) {
        var s = self.subscriptions[modelName] = self.subscriptions[modelName] || { name: modelName, timeOut: 0, calcCntr: 0 };
        var store = XPortal.Store.AppStore;
        s.unsubscribe = s.unsubscribe || store.subscribe(() => {/*update calc field values*/
            var state = XPortal.Store.GetBaseReduserState();
            if (!state.pageModels.hasOwnProperty(modelName)) return;
            var laction = store.getState().lastAction;
            var mustContinue = s.timeOut == 0 && modelName.toLowerCase() == (laction.model || laction.modelName || "").toLowerCase();
            if (!mustContinue && !laction.field) return;
            if (!state.pageModels.hasOwnProperty(modelName)) return;
            subscribeStaticText(modelName, $(selector));
            if (isCalcFieldWereModified(state, modelName, laction)) return;

            clearTimeout(s.timeOut);
            s.timeOut = setTimeout(function () {
                var onEnd = () => self.updateExtendedFormating(modelName);
                self.updateCalcFieldsData(modelName, $(selector)).then(onEnd, onEnd);
            }, 500);
        });
    };

    self.SaveChildsHierarchy = function (options, model) {
        return new Promise((onOk, onErr) => {
            if (options && options.notClose) { //need to refresh updated items
                XPortal.Store.SaveInlineItemsRefresh(true, false, model.modelName || (model.model ? model.model.modelName : null));
                onOk();
            } else XPortal.Store.SaveStoreItemsDefer(true, false, model.modelName || (model.model ? model.model.modelName : null)).then(onOk, onErr);
        });
    };
    self.SavePendingData = function (options) {
        options = options || {};
        const modelName = options.modelName || XPortal.Store.getTopModelNameToSave();
        if (!modelName || !modelName.startsWith("GM."))
            return self.SaveData(modelName, options).then(function () {
                if (XPortal.Store.IsEntityToSavePresent()) return $.Deferred().reject({ errorsDisplayed: true });
            });
        return savePendingInlineModels();
    };
    function savePendingInlineModels() {
        const deferredSave = $.Deferred();
        if (!XPortal.GridInlineEditing.ValidateAllGridModels()) return deferredSave.reject({ validationErrors: self.GetGridValidationErrors() }).promise();
        XPortal.Store.SaveStoreItemsDefer(true, false).then(function (results) {
            const failed = (results || []).filter(r => r.rejected
                || (r.resolved && r.resolved[0] && XPortal.GridInlineEditing.IsFailedSaveResult(r.resolved[0].result)));
            if (failed.length < 1) return deferredSave.resolve(results);
            const errorsDisplayed = failed.some(r => !!r.rejected
                || (self.GetErrorMessages([r.resolved[0].result]) || []).length > 0);
            deferredSave.reject({ errorsDisplayed });
        }, function () {
            deferredSave.reject({ errorsDisplayed: true });
        });
        return deferredSave.promise();
    };
    self.DetailSucess = function (data) {
        XPortal.Utils.EnsureCollectionEvent("after-save", function (e) {
            e.form = frm;
            e.data = fdata;
            e.rdata = data;
            return e;
        }, frm.find(fieldClass), function () {
            if (frm.find(".detail-field-error").length < 1) {
                callback = XPortal.EditForm.getEventHandlerFor(frm, "data-ajax-ondone");
                if (callback && typeof callback === "function") callback.apply(this, data);
            }
        });
        if (data.Result) {
            $("#editFormSettings").data("uid", data.Result[0].UniqueEId);
            $("#editFormSettings").data("changed", false);
            $("#editFormSettings").data("creating", false);
            dfd.resolve(data);
        } else
            dfd.reject(data);

    };
    self.ShowErrorMessage = function (done, localizedMessage, localizedBody) {
        localizedBody = localizedBody || "";
        XPortal.Modal.alert({
            showModal: true,
            headerText: localizedMessage,
            alertText: done && done.Errors ? done.Errors.join() : done && done.validationErrors ? localizedBody + "<p>" + done.validationErrors.join("<br/>") + "</p>" : localizedBody
        });
    };
    self.ShowServerErrorMessages = function (dataArr) {
        const messages = self.GetErrorMessages(dataArr);
        if (messages.length > 0) {
            XPortal.Localization.GetLocalizedStrings("XFModal.Error.Title", "XFModal.Error.Save.Body").then(function (items) {
                XPortal.EditForm.ShowErrorMessage({ validationErrors: messages }, items["XFModal.Error.Title"] || "", items["XFModal.Error.Save.Body"] || "");
            });
        }
    };
    self.GetErrorMessages = function (data) {
        if (!data || data.length < 1) return;
        var messages = [];
        data.forEach(function (x) {
            (x.Messages || []).forEach(function (m) {
                if (m && m.State == -417)
                    messages.push(`${getMessageGroup(m.GroupCode)}${m.Message}`);
            });
        });
        return messages;
    }
    function getMessageGroup(msgGroup) {
        const vals = msgGroup.split("|");
        return msgGroup && vals.length > 1 ? `${vals[1]}: ` : msgGroup;
    }
    self.CloseDetails = function () {
        //do not close if detail form must be opened
        if (XPortal.Store.ForceCloseForm()) {
            var breadcrumbItem = $("#breadcrumb-menu > li:nth-last-child(2) > a");
            if (breadcrumbItem.length > 0) {
                var url = breadcrumbItem.attr("href");
                self.SetBreadcrumbUrl({
                    url: url,
                    breadcrumbElement: breadcrumbItem[0]
                });
            } else {
                window.location.reload(true);
            }
        }
    };
    self.PrepareData = function ensureFormDataBeforeSend(data, sttgs) {
        var container = sttgs && sttgs.container ? $(sttgs.container) : $(".edit-form");
        var r = {
            Keys: [],
            Fields: [],
            UniqueId: sttgs.containerform.attr("uniqueid"),
            NodeId: sttgs.containerform.attr("entitydetailid"),
            EntityAlias: sttgs.containerform.attr("alias")
        };

        r.isCreating = $("#editFormSettings").data("creating");
        container.find(".detail-keyfield").each(function (ep, eldom) {
            var el = $(eldom);
            r.Keys.push({ field: el.attr("data-name"), data: el.val(), ftype: el.attr("data-type") });
        });
        r.Fields = self.ProcessDetailFields(container);
        return {
            model: r
        };
    };
    //model for redux
    function prepareReduxModel(sttgs) {
        const container = sttgs && sttgs.container ? $(sttgs.container) : $(".edit-form");
        const keys = [];
        container.find(".detail-keyfield").each(function (ep, eldom) {
            var el = $(eldom);
            keys.push({ field: el.attr("data-name"), data: el.val(), ftype: el.attr("data-type") });
        });
        return {
            model: Object.assign({
                Keys: keys,
                Fields: [],
                ParentInfo: XPortal.Utils.hrefQuery(window.location, "parentInfo")
            }, sttgs.model)
        };
    };

    self.PrepareReduxFields = function (container, className) {
        var fields = [];
        var fieldIndex = {};
        var searchPattern = className || self._fieldSelector;
        container.find(searchPattern).each(function (ep, eldom) {
            const el = $(eldom);
            const esttg = XPortal.Main.GetSettingsFor(el);
            esttg.ismultiselect = el.hasClass("xpand-multiselect");
            if (esttg.fieldname || esttg.type) {
                var fdata = {
                    Name: esttg.fieldname,
                    ftype: esttg.type,
                    Type: esttg.type,
                    editable: esttg.editable,
                    isChanged: el.data("IsChanged"),
                    ismultiselect: esttg.ismultiselect,
                    StringValue: esttg.value
                };

                fdata.StringValue = el.attr("value") ? el.attr("value") : el.data() && el.data().value ? el.data().value : fdata.StringValue;
                if (fdata.StringValue === "" && el.length > 0)
                    fdata.StringValue = el[0].value;
                var key = fdata.Name.toLowerCase();
                if (fieldIndex.hasOwnProperty(key)) {
                    fields[fieldIndex[key]] = fdata;
                } else {
                    fieldIndex[key] = fields.length;
                    fields.push(fdata);
                }
            }
        });
        return fields;
    };

    self.ProcessDetailFields = function (container, className, useValueOnly) {
        var fields = [];
        var searchPattern = className || self._fieldSelector;
        container.find(searchPattern).each(function (ep, eldom) {
            var el = $(eldom);
            var fieldMetadata = {};
            $.each(_.filter(el[0].attributes, function (a) {
                return a.name.startsWith("data-metadata-");
            }), function (ix, a) {
                fieldMetadata[a.name.substring(14).toLowerCase()] = a.value;
            });
            var fdata = {
                field: fieldMetadata.fieldname,
                ftype: fieldMetadata.type,
                isChanged: el.data("IsChanged")
            };

            if (fdata.field) {
                if (fdata.ftype === "Date" || fdata.ftype === "DateTime") {
                    if (typeof ($(el)).getKendoDatePicker() != 'undefined') {
                        var dateTimeVal = $(el).getKendoDatePicker().value();
                        fdata.data = dateTimeVal === null ? '' : XPortal.Utils.customISOstring(dateTimeVal, dateTimeVal.getTimezoneOffset());
                    }
                } else if (fdata.ftype === "Boolean" && el.length > 0) {
                    fdata.data = el[0].checked === true ? 1 : 0;
                } else {
                    var elVal = el.val();
                    if (!useValueOnly && el.attr("data-value") && (!elVal) && el.attr("data-value")) elVal = el.attr("data-value");
                    fdata.data = elVal;
                }
                if (!Array.isArray(fdata.data)) { // since we can't convert string[] to string on .Net side we omit  arrays 
                    fields.push(fdata);
                }
            }
        });
        return fields;
    };
    //detail edit/save custom actions url changes
    self.ModifyUrlAfterNewRecordSave = function (url) {
        if (url.indexOf('new=') > -1) {
            var newId = XPortal.Utils.hrefQuery(url, 'new');
            var editParams = XPortal.Store.GetState().editParameters;
            if (newId && editParams && editParams.UniqueId) {
                url = url.replace('new=' + newId, "id=" + editParams.UniqueId);
            }
        }
        return url;
    };

    self.SetNewRecordLocationUrl = function (params, url) {
        if (!params)
            return;
        var kendoGrid = params.grid && params.grid.options ? params.grid : params.grid.data("kendoGrid");
        var d = kendoGrid && kendoGrid.options && kendoGrid.options.pageData ? kendoGrid.options.pageData.details : null;
        var gridId = kendoGrid.element.attr("data-id");
        var parentInfo = XPortal.Grid.dictionaryParent[gridId];
        d.parentInfo = parentInfo;
        var bc = self.PrepareBCstring(undefined, url);

        if (d && d.url && d.url.length > 0) {
            const durl = XPortal.Utils.GetPathFromUrl(d.url);
            var linkTemplate = durl + "?new=" + kendo.guid() +
                (d.parentInfo && d.parentInfo.length > 0 ? "&parentInfo=" + d.parentInfo : "") +
                XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            if (params.returnUrlOnly)
                return linkTemplate;

            window.location.href = linkTemplate;
        } else XPortal.Modal.alert({
            headerText: kendoGrid.options.messages.addnew.warningtitle,
            alertText: kendoGrid.options.messages.addnew.nodetaillinkfound
        });
    };
    self.SetMoveLocationUrl = function (params, url) {
        window.location = params.url;
    };
    self.SetBreadcrumbUrl = function (params) {
        var breadcrumbPart = params.breadcrumbElement.getAttribute("parsedpart");
        var index = params.breadcrumbElement.dataset.index;
        if (window.location.href.indexOf(breadcrumbPart) > -1) {
            var currentBCparts = XPortal.Utils.hrefQuery(window.location.href, "bc").split(",");
            currentBCparts.splice(index);
            let url = params.url + (currentBCparts.length > 0 ? (XPortal.Main.BreadCrSep + encodeURIComponent(currentBCparts.join(","))) : "");
            window.location = url.replace("/&", "/?"); //if we set BC for list item WO parameters
        } else
            window.location = params.url;
    };
    self.GetReturnNode = function () {
        var dashBoardElement = $("div.content.dashboard-page");
        var editForm = $(".detail-page .edit-form");
        let uid = null;
        let nodeId = null;
        if (dashBoardElement.length) {
            nodeId = dashBoardElement.find("div.row.fe-area").first()[0].id;
        } else if (editForm.length) {
            const modelName = XPortal.Store.getModelName(editForm.closest(".detail-page"));
            const model = XPortal.Store.GetModelByName(modelName);
            const entity = model ? model.entity : null;
            uid = entity ? entity.UniqueId.replace(/-/g, "") : null;
            nodeId = entity ? entity.NodeId : null;
        } else {
            var grid = $("div[id^='entity-grid-']");
            if (grid.length)
                nodeId = $("div[id^='entity-grid-']").data().id;
        }

        return { NodeId: nodeId, Uid: uid };
    };
    self.PrepareBCstring = function (nodeId, url) {
        if (url.indexOf(XPortal.Main.BreadCrSep.substr(1)) > -1) {
            bc = XPortal.Utils.hrefQuery(url, "bc");
        }
        var node = self.GetReturnNode();
        nodeId = nodeId || node.NodeId;
        if ($("#editFormSettings").length > 0 && $("#editFormSettings").data("creating")) {
            return (bc ? decodeURIComponent(bc) : "");
        }
        var curBc = (bc ? decodeURIComponent(bc) + XPortal.Main.BreadCrPartSep : "");
        if (curBc.split(",").length > 5) {
            var itms = curBc.split(",");
            curBc = itms.slice(itms.length - 6).join(",");
        }
        var bc = curBc + nodeId + (node.Uid ? XPortal.Main.BreadCrUidSep + node.Uid : "");
        return bc;
    };
    self.SetEditLocationUrl = function (params, bcUrl, activeRow) {
        var gridData = params.grid ? params.grid.data("kendoGrid") : undefined;
        var url = params.url ? params.url : gridData.options.pageData.details.url;
        var node = self.GetReturnNode();
        var nodeId = node.NodeId || (params.nodeId ? params.nodeId : gridData.options.pageData.nodeId);
        var parentInfo = gridData ? gridData.options.pageData.details.parentInfo : null;
        var bc = self.PrepareBCstring(undefined, bcUrl);
        if (params.uid) {
            var editedObjLink = XPortal.Template.ReplaceFormatString(url + "?id=" + params.uid +
                "&r=[[newguid]]" + (parentInfo && parentInfo.length > 0 ? "&parentInfo=" + parentInfo : ""), "", null, nodeId);
            if (params.returnUrlOnly)
                return editedObjLink;
            window.location = editedObjLink + XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            return;
        }

        activeRow = activeRow ? activeRow : gridData.table.find("tr.k-state-selected");
        var selectedrows = XPortal.GridActions.GetXSelectedRows(params.grid);
        $(selectedrows).addClass("k-state-selected");

        if (activeRow.length === 0) {
            if (selectedrows.length > 0) {
                activeRow.push(selectedrows[0]);
            } else XPortal.Modal.alert({
                headerText: (gridData.options.messages.edit || gridData.options.messages.sendmail || {}).warningtitle || "",
                alertText: XPortal.GridActions.GetWarningMsg(params.grid.closest(".grid-parent").find(".toolbar"))
            });
        }
        if (activeRow.length) {
            var editedObj = gridData.dataItem(activeRow[0]);
            var d = gridData.options.pageData ? gridData.options.pageData.details : null;
            if (d && d.url && d.url.length > 0) {
                editedObjLink = XPortal.Template.ReplaceFormatString(d.url + "?id=[[UniqueId]]&r=[[newguid]]" +
                    (parentInfo && parentInfo.length > 0 ? "&parentInfo=" + parentInfo : ""), "", editedObj, nodeId);
                if (params.returnUrlOnly)
                    return editedObjLink;
                window.location = editedObjLink + XPortal.Main.BreadCrSep + encodeURIComponent(bc);
            } else {
                XPortal.Modal.alert({
                    headerText: gridData.options.messages.edit.warningtitle,
                    alertText: gridData.options.messages.edit.nodetaillinkfound
                });
            }
        }
    };

    self.RegisterEvents = function (container) {
        //show confirmation message before move to any link
        $(container).on('click', 'a', function (e) {
            if ($(this).hasClass("open-in-dialog"))
                return self.ShowActionDialog(e, this, e.target);
            if (XPortal.Main.isNonActionLink(this, e.target))
                return;
            if ($('.fe-jscountdown-cntr').length)
                return;
            e.preventDefault();
            XPortal.GridActions.ShowPage({
                action: this.hasAttribute("parsedpart") ? XPortal.EditForm.SetBreadcrumbUrl : XPortal.EditForm.SetMoveLocationUrl,
                url: $(this).attr('href'),
                breadcrumbElement: this.hasAttribute("parsedpart") ? this : undefined
            });
        });
        $(container).on('click', '.tags-format-container .edit-tags, .detail-page .add-tag', function (e) {
            self.ShowTagsDialog(e, this, e.target);
            setTimeout(function () {
                const editorKey = $(e.target).closest(XPortal.TagsEditor.controlSelector).find(XPortal.TagsEditor.controlInputSelector).data("editorkey");
                const $typeahead = XPortal.TagsEditor.$typeaheads[editorKey] || XPortal.TagsEditor.$typeahead;
                $typeahead.typeahead('val', " ").trigger("focus");
                $typeahead.typeahead('val', '');
            }, 500);
        });
        $(container).on('change', '.detail-field[data-editable="1"]', function (e) {
            if (e.currentTarget) $(e.currentTarget).data("IsChanged", true);
            $("#editFormSettings").data("changed", true);
            //refresh dropdowns
            if (e.target && e.target.dataset.metadataFieldname)
                XPortal.Dropdown.updateFor(e.target.dataset.metadataFieldname, $(e.target).closest(XPortal.Main.DetialFormSelector));
        });

        $(container).on('click', 'a.alerts-show-all-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $sumBlock = $(e.currentTarget).closest(".alert-summary-content");
            $sumBlock.find(".alert-show-less").removeClass("d-none");
            $sumBlock.find(".alerts-show-all-btn").addClass("d-none");
            $sumBlock.find(".alerts-show-less-btn").removeClass("d-none");
        });
        $(container).on('click', 'a.alerts-show-less-btn', function (e) {
            e.preventDefault();
            e.stopPropagation();
            const $sumBlock = $(e.currentTarget).closest(".alert-summary-content");
            $sumBlock.find(".alert-show-less").addClass("d-none");
            $sumBlock.find(".alerts-show-all-btn").removeClass("d-none");
            $sumBlock.find(".alerts-show-less-btn").addClass("d-none");
        });

        $(container).on('show.bs.dropdown', '.grid-col-alert', function () {
            const $container = $(this);
            let $alertMenu = $container.find('.dropdown-menu.alert-summary-content');
            if ($alertMenu.length === 0) {
                $alertMenu = $('body').children('.dropdown-menu.alert-summary-content');
            }

            const offset = $container.offset();
            const height = $container.outerHeight();
            const width = $container.outerWidth();
            $alertMenu.appendTo('body');

            $alertMenu.css({
                top: (offset.top + height) + 'px',
                left: offset.left + 'px',
                minWidth: width + 'px'
            });
        });

        $(container).on('hide.bs.dropdown', '.grid-col-alert', function () {
            const $container = $(this);
            const $menu = $('body').children('.dropdown-menu.alert-summary-content');

            $container.append($menu);

            $menu.css({
                top: '',
                left: '',
                minWidth: ''
            });
        });
    };
    self.ShowActionDialog = function (e, domEl, target) {
        if (e) e.preventDefault();
        const el = $(domEl);
        const elSettings = XPortal.Utils.readJsonStr(el.attr("data-sttgs"), { dialog: {} });
        return getActionDialogPopupOpts(elSettings, el.attr("href"), el.attr("data-nodeid"))
            .then(function (opts) {
                const $modal = opts.popupObj.find(".modal-dialog");
                $modal.on("action-completed", function (e, argObj) {
                    let closeModal = argObj.closeModal;

                    if (argObj.redirectToUrl) {
                        const isSame = XPortal.Utils.CompareUrlPaths(window.location.href, argObj.redirectToUrl);
                        if (isSame) closeModal = true;
                        else window.location.href = argObj.redirectToUrl;
                    }
                    if (closeModal)
                        XPortal.Modal.closeModal(null, opts.boxSelector || "#extended-popup-box");
                    $modal.trigger("refresh-org-grid");
                    $modal.trigger("refresh-entity", argObj);
                });
                $modal.on("refresh-entity", function (e, argObj) {
                    const refreshData = el.attr("data-refresh-data");
                    if (refreshData !== "1") return;
                    setTimeout(function () {
                        window.location.reload();
                    }, 300);
                });
                $modal.on("refresh-org-grid", function (e, argObj) {
                    let grid = el.closest(".grid-parent").find(".entity-grid");
                    if (!grid.length) grid = $("#entity-grid-" + el.attr("data-nodeid"));
                    if (grid.length) {
                        const ginfo = XPortal.Grid.GetGridInfo(grid);
                        ginfo.kgrid.dataSource.read();
                        ginfo.kgrid.refresh();
                    }
                });
            }, function (opts, ...args) { });
        //popupOpts.showStep(".wsection.finish");
    };

    function cleanUpPopupPageModels(e, opts) {
        const modObj = $(e.currentTarget);
        const $popup = modObj.find(XPortal.Main.DetialFormSelector);
        const state = XPortal.Store.GetState();
        let parentModelName = "";
        if ($popup.length) {
            parentModelName = XPortal.Store.getModelName($popup.attr("id"));
            for (var key in state.pageModels) {
                if (state.pageModels[key].model.modelPath && state.pageModels[key].model.modelPath.indexOf(parentModelName) >= 0)
                    delete state.pageModels[key];
            }
        }
        for (var key in state.pageModels) {
            const jsel = state.pageModels[key].model.selector;
            if (jsel && modObj.has(jsel).length)
                delete state.pageModels[key];
        }
        state.editParameters = opts.stateEditParameters;
        modObj.html("");

        // trigger dispose popup controls
        $(document).trigger("popup:dispose", { modalBox: modObj, popupRoot: $popup, popupRootModelName: parentModelName });

        const modelName = opts.parentNodeId ? XPortal.Store.GetModelByNodeId(opts.parentNodeId) : null;
        XPortal.EditForm.RefreshParentModel(modelName);
    };
    self.CleanUpPopupPageModels = cleanUpPopupPageModels;

    self.ShowTagsDialog = function (e, domEl, target) {
        e.preventDefault();
        const el = $(domEl);
        const { opts, item } = XPortal.TagsEditor.PrepareTagsDialogOpts(el);
        if (!opts || !item) return;
        XPortal.TagsEditor.GetTagsDialogPopup(opts, item, el)
            .then(function (opts) {
                opts.popupObj.find(".modal-dialog").on("action-completed", function (e, argObj) {
                    XPortal.Modal.closeModal(null, "#extended-popup-box");

                    const model = XPortal.Store.GetModelByName(argObj.modelName).model;
                    const pageId = model.NodeId;
                    let grid = $("#entity-grid-" + pageId);
                    if (grid.length) {
                        const ginfo = XPortal.Grid.GetGridInfo(grid);
                        ginfo.kgrid.dataSource.read();
                        ginfo.kgrid.refresh();
                    }
                });
            }, function (opts, ...args) {
            });
    };

    function getActionDialogPopupOpts(aOpts, rurl, nid) {
        const opts = aOpts.dialog || {};
        const selector = $(opts.boxSelector || '#extended-popup-box');
        opts.confirmedUnsavedChanged = false;
        if (!opts.ReqMethod && aOpts.isExternal) opts.ReqMethod = "GET";
        opts.maxHeight = opts.maxHeight ? opts.maxHeight : opts.height;
        opts.strSettings = JSON.stringify(opts);
        opts.showStep = function (stepSelector, evnName) {
            opts.popupObj.find(".wsection").addClass("d-none");
            opts.popupObj.find(".modal-body-footer a").hide();
            opts.popupObj.find(stepSelector).removeClass("d-none");
            if (evnName) opts.popupObj.trigger(evnName);
        };

        showHidePopupLoader(opts, true);

        opts.template = (opts.template || "").toLowerCase();
        opts.templateContainer = $("<div></div>");
        opts.templateContainer.html(XPortal.Template.TemplateToHtml(opts, $(opts.templateSelector || "#popup-detail-page").html()));
        var state = XPortal.Store.GetState() || { editParameters: {} };
        opts.stateEditParameters = Object.assign({}, state.editParameters || {});
        opts.parentNodeId = nid;
        opts.popupObj = XPortal.EditActions.initModalPopup(selector, opts, false, false,
            e => cleanUpPopupPageModels(e, opts), true,
            e => {
                alertIfUnsavedChanged(e, opts);
                XPortal.Modal.BlurFocusedElement();
            });

        return new Promise((onOk, onError) => {
            const content = opts.popupObj.find(".popup-detail-content");

            content.on("redirect-request", function (e, robj, status, xhr) {

                for (var i = 0; i < processing.length; i++)
                    processing[i].blocked = true;

                requestPopupContent(robj.url);
            });
            const processing = [];
            var requestPopupContent = function (iurl) {
                const stage = { url: iurl, blocked: false };
                processing.push(stage);
                const cleanUpPopup = function () {
                    XPortal.Utils.waitFor(function () {
                        if (stage.blocked) return true;
                        const isCompleted = initCompletePopupPage(content, opts);
                        if (!isCompleted) return false;

                        showHidePopupLoader(opts, false);
                        return true;
                    }, XPortal.Utils.waitFor, 500, 100);
                };
                const ajaxReq = {
                    method: opts.ReqMethod || "POST",
                    dataType: "html",
                    cache: false,
                    contentType: "application/json; charset=utf-8",
                    url: XPortal.Utils.EnsureInProfile(iurl),
                    //data: kendo.stringify({}),
                    headers: {
                        viewmode: "Popup",
                        RequestVerificationToken:
                            XPortal.Main.getAntiForgeryToken(),
                    },
                    success: function (xcontent) {
                        if (stage.blocked) return true;

                        content.html(xcontent);
                        XPortal.Dashboard.Init(content);
                        XPortal.Grid.PreInit(content);
                        init(content, null);
                        cleanUpPopup();
                        onOk(opts);
                    },
                    error: async function (...args) {
                        showHidePopupLoader(opts, false);
                        const $modalElement = $(opts.boxSelector || "#extended-popup-box");
                        $modalElement.modal('hide');
                        $('.modal-backdrop').remove();
                        $('body').removeClass('modal-open').css('padding-right', '');

                        let items = {};
                        try {
                            items = await XPortal.Localization.GetLocalizedStrings(
                                "XFModal.Error.Title",
                                "XFModal.Error.CannotOpenPopup",
                            );
                        } catch (error) { }

                        const defaults = {
                            "XFModal.Error.Title": '<i class="icon-error-warning"></i> Error',
                            "XFModal.Error.CannotOpenPopup": "The link cannot be opened in a pop-up window due to a server issue.",
                        };
                        const strings = {
                            title: items["XFModal.Error.Title"] || defaults["XFModal.Error.Title"],
                            body: items["XFModal.Error.CannotOpenPopup"] || defaults["XFModal.Error.CannotOpenPopup"]
                        };

                        const errorContent = `
                            <div class="error-content">
                                <p>${strings.body}</p>
                                <div class="mt-3">
                                    <a href="${iurl}" target="_blank">
                                        <i class="icon-external-link"></i> Open in new tab
                                    </a>
                                </div>
                            </div>`;

                        XPortal.Modal.alert({
                            showModal: true,
                            headerText: strings.title,
                            alertText: errorContent
                        });

                        onError(opts, args);
                    }
                };
                $.ajax(ajaxReq);
            };

            requestPopupContent(rurl, processing.length);
        });
    };
    function alertIfUnsavedChanged(e, opts) {
        //Are there changes to save
        e.result = opts.confirmedUnsavedChanged || (XPortal.Store.IsEntityToSavePresent(XPortal.Store.GetState(), false, function (itms) {
            if (itms && itms.length > 0) {
                for (var i = 0; i < itms.length; i++) {
                    const popContains = opts.popupObj.has(XPortal.Store.GetModelByName(itms[i].key).model.selector);
                    if (popContains.length) return true;
                }
            }
            return false;
        }, false) == false);

        if (e.result == false) {
            e.preventDefault();
            e.stopPropagation();
            XPortal.GridActions.ShowPage({
                action: function () {
                    cleanUpPopupPageModels({ currentTarget: opts.popupObj }, opts);
                    opts.confirmedUnsavedChanged = true;//to prevent circle check
                    XPortal.Modal.hideModal(opts.popupObj);
                }
            });
        }
        return e.result;
    };
    function showHidePopupLoader(opts, show) {
        if (show) {
            XPortal.Loader.show({ showDelayTime: 0, selector: '.loading-block' });
            return;
        } else {
            opts.popupObj.find(".loading-block>.loader").removeClass('hidden');
        }
        let lastHeight = -1;
        XPortal.Utils.waitFor(function () {
            const loadblock = opts.popupObj.find(".loading-block");
            if (lastHeight != loadblock.height()) {
                lastHeight = loadblock.height();
                return false;
            }
            loadblock.hide();
            return true;
        }, XPortal.Utils.waitFor, 500, 100);
    };
    self.ShowHidePopupLoader = showHidePopupLoader;

    function initCompletePopupPage(content, opts) {
        if (!opts._completelastHeight) opts._completelastHeight = -1;
        const $page = content.find(".dashboard-page, .items-list-page, .html-page, .detail-page").first();
        let height = $page.height();
        if (height !== opts._completelastHeight) {
            opts._completelastHeight = height;
            return false;
        }

        const modalTitle = opts.title ? opts.title.trim() : "";
        const $headerCnt = opts.popupObj.find('.modal-header .modal-header-cnt');

        if (modalTitle.length > 0) {
            $headerCnt.html(modalTitle);
            const $target = $page.find("h1, .page-title-wrp, .block-header-title").first();
            const $parent = $target.closest('.block-header__title-wrp');

            $target.remove();
            $parent.empty();
        } else {
            const $title = $page.find("h1, .page-title-wrp, >.row>.xsection>.xbgdecoration-wrap>.block-header>.block-header__title-wrp>.block-header-title").first();

            if ($title.length && $title.text().trim() !== "") {
                const $parent = $title.closest('.block-header__title-wrp');
                $title.find('i[class^="icon-"]').remove();

                $headerCnt.html($title.html());

                $title.remove();
                $parent.empty();
            }
        }
        return true;
    };

    function moveEditButtonsToFooter($page, $footer) {
        const $btnsWrpr = $page.find(".edit-btns-wrapper .edit-btns");
        if ($btnsWrpr.length === 0) return false;
        $footer.find(".edit-btns").remove();
        const $actionWrapper = $btnsWrpr.find(".detail-top-buttons-wrapper");
        $actionWrapper.removeClass("opacity-0");
        $actionWrapper.find("> .dropdown").removeClass("d-none");
        $btnsWrpr.appendTo($footer);

        XPortal.DropdownBtns.gridButtons.check($btnsWrpr);
        return true;
    };

    self.OnPopupContentAjaxCompleted = function (dstContainer, response, status, xhr) {
        const iresponse = $("<div>" + response + "</div>");
        const redirectElem = iresponse.find("input#RedirectUrl");
        iresponse.RedirectUrl = !redirectElem.hasClass("ignor-ajax-reload") ? (redirectElem.val() || response.RedirectUrl) : "";
        iresponse.State = iresponse.find("input#State").val() || response.State;
        if (iresponse.RedirectUrl && iresponse.RedirectUrl.length > 0) {
            return $(dstContainer).closest(".popup-detail-content")
                .trigger("redirect-request", { url: iresponse.RedirectUrl, state: iresponse.State }, status, xhr);
        }
    };
    self.RegisterEvents(document);
    self.updateCalcFieldsData = function (modelName, container) {
        return new Promise(function (onOk, OnErr) {
            var model = XPortal.Store.GetModelByName(modelName);
            var uid = XPortal.Template.GetObjPropValueByName(model.entity, "uniqueid");
            var frm = container.find(".edit-form");
            var headers = XPortal.EditActions.FillHeaders({ container: frm });
            var calcFields = model.model.Schema.fields.filter(x => x.isCalc);
            if (calcFields && calcFields.length) {
                XPortal.Grid.ExecuteUpdateCalcFieldsData([uid], model.model.NodeId, { EntityAlias: model.model.Alias, parentInfo: model.model.ParentInfo }, headers)
                    .then(function (result) {
                        var item = result && result.Items ? result.Items.find(x => uid == XPortal.Template.GetObjPropValueByName(x, "uniqueid")) : null;
                        if (item) {
                            item = XPortal.Grid.MapEntity(item, null);
                            model = XPortal.Store.GetModelByName(modelName);
                            calcFields.forEach(f => {
                                const nl = XPortal.Template.GetObjPropName(model.entity, f.fieldName);
                                let nv = XPortal.Template.GetObjPropValueByName(item, f.fieldName);
                                nv = nv != null ? String(nv) : nv;
                                model.entity.Fields = model.entity.Fields || [];
                                let fe = model.entity.Fields.find(fi => fi.Name == f.fieldName);
                                if (!fe)
                                    entity.Fields.push(fe = { Name: afname, Type: action.field.ftype });

                                model.entity[nl] = fe.StringValue = nv;
                                XPortal.Store.DispatchWithoutEvents(modelName, f.fieldName, nv, true);
                            });
                        }
                        onOk();
                    }, OnErr);
            }
            else onErr();
        });
    };
    self.updateExtendedFormating = function (modelName) {
        return new Promise(function (onOk, OnErr) {
            var data = XPortal.Store.GetModelByName(modelName);
            if (!data || !data.model || !data.model.Schema) return;
            var withEFormat = data.model.Schema.fields.filter(x => x.formatExtended && x.formatExtended.Method);
            if (withEFormat.length < 1) onOk();
            var container = $(data.model.selector);
            var exformats = [];
            container.find(".field-ex-format").each((xi, x) => exformats.push(x));
            withEFormat.forEach(f => {
                if (f.id) f.id = f.id.toLowerCase();
                var exfrmt = exformats.find(ef => ($(ef).attr("data-cid") || "").toLowerCase() == f.id);
                if (!exfrmt) return;
                exfrmt = $(exfrmt);
                try {
                    loadFormatMethod(data.model, f, exfrmt);
                    exfrmt.html((f.funct) ? f.funct(data.entity, f.template, f) : "");
                } catch (e) {
                    exfrmt.html("");
                    if (console) console.log("updateExtendedFormating error", e);
                }
                markEmptyExFormat(exfrmt);
            });
        });
    };
    function markEmptyExFormat(exfrmt) {
        var text = (exfrmt.text() || "").replace(/[\s\-]/g, "");
        var hasMedia = exfrmt.find("img, svg, input, i[class], .progress-bar__wrapper, .grid-alert-wrapper").length > 0;
        exfrmt.toggleClass("is-empty", !text && !hasMedia);
    };
    function isCalcFieldWereModified(state, modelName, laction) {
        if (!state || !state.pageModels) return false;
        var model = (state.pageModels[modelName] || {}).model;
        if (!model || !model.Schema) return false;
        if (!laction || !laction.field || !laction.field.field) return false;
        var field = (laction.field.field || "").toLowerCase();
        if (field == "*") return false;
        var isCalc = model.Schema.fields.filter(x => x.isCalc && x.fieldName.toLowerCase() == field);
        return isCalc && isCalc.length ? true : false;
    };
    function loadFormatMethod(model, field, container) {
        if (!field) return null;
        if (!field.template && field.template != '') field.template = (container.find("script").html() || "").trim();
        if (!field.funct) field.funct = new Function('item', 'htmlTemplate', 'fopts', 'return ' + field.formatExtended.Method + '(item, "' + field.type + '", "' + field.fieldName + '", null, ' + model.NodeId + ', htmlTemplate, fopts)');
        return field.funct;
    };
    function GetOptions(modelName) {
        const state = XPortal.Store.GetBaseReduserState();
        const currentModel = state.pageModels[modelName];
        const container = $(currentModel.model.selector);
        const containerWithActions = (currentModel.isPopup) && container.closest(".modal-content").length ? container.closest(".modal-content") : container;
        const button = containerWithActions.find("[data-action=SaveDetail]");
        const isCreating = currentModel.model.IsCreating ? true : false;
        return { modelName, container, button, notClose: true, silentMode: true, doNotDisplayErrors: isCreating, IsCreating: isCreating };
    };

    self.LinkAction = function (opts, itemObj, exInfo, refreshData) {
        const { modelName, nodeId, pinfo, button, selrows, where } = exInfo;

        //const rowid = itemObj ? XPortal.Template.GetObjPropValueByName(itemObj, "uniqueid") : null;
        const sttgs = Object.assign({ settings: { dialog: opts.dialog }, item: itemObj, nodeId, pinfo });
        const linkHtml = XPortal.Format.GetLinkHtml(sttgs, opts);
        let $el = $(linkHtml).addClass("d-none action-link-a").attr("data-nodeid", sttgs.nodeId).attr("data-refresh-data", refreshData ? "1" : "0");
        $el.appendTo($("body"));
        $el[0].click();
        $el.remove();
    };
    return self;
}());
